










import { Component, Mixins } from 'vue-property-decorator'
import CookieMethods from '@/mixins/CookieMethods.vue'
import ButtonBase from '@/components/common/atoms/ButtonBase.vue'

@Component({
  components: {
    ButtonBase,
  },
})
export default class AuthedHeader extends Mixins(CookieMethods) {
  /**
   * ログアウト処理
   *
   * クッキーを削除しログイン画面へ遷移する
   */
  private async logout() {
    await this.resetAuthAcbt()
    this.$router.push({ name: 'BranchLogin' })
  }

  private get currentRouteName() {
    return this.$route.name
  }
  private hideLogout() {
    return !(this.currentRouteName == 'BranchStudyResult')
  }
}
